module.exports = __webpack_public_path__ + "static/consultaN-8ab5b02589a3d2e56af748acb147f468.jpg";